// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bVZY","colBig":"styles_colBig__X5zqk","colSmall":"styles_colSmall__2zihQ"};